import api from '@/store/api/customer/product/number/billings/billing'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    billing: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        billing: state => state.billing
    },
    actions: {
        showBilling: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showBilling(data)
                commit(mutationTypes.SET_NUMBER_BILLING, response)

                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        updateBilling: async ({ dispatch }, data) => {
            try {
                return await api.updateBilling(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        deleteBilling: async ({ dispatch }, data) => {
            try {
                return await api.deleteBilling(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetBilling: async ({commit}) => commit(mutationTypes.RESET_NUMBER_BILLING)
    },
    mutations: {
        [mutationTypes.SET_NUMBER_BILLING]: (state, data) => state.billing = data,
        [mutationTypes.RESET_NUMBER_BILLING]: (state) => Object.assign(state, initialState())
    }
}
